import { Box } from "@mui/material";
import { statusToPill } from "../utils";

import type { MomentCardMoment } from "../types";
import type { BoxProps } from "@mui/material";
import type { FC } from "react";

interface MomentPillProps extends BoxProps {
  status: MomentCardMoment["status"];
}
export const MomentPill: FC<MomentPillProps> = ({ status, ...props }) => {
  if (!status) return null;
  return <Box {...props}>{statusToPill(status)}</Box>;
};
